import React, { useCallback, useLayoutEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CommonSelect, CommonToolTip, CstmPagination } from "../../../../components/Common/Common";
import { generatePath, Link, useNavigate } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useArchivePrivateClientMutation, useDeletePrivateClientMutation, useFavouritePrivateClientMutation, useGetPrivateClientListQuery, useUpdatePrivateClientStatusMutation } from "store/services/clients/private.client";
import TableHeader from "components/shared/FormComponents/TableHeader";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { convertToMomentDate, dateFormatLocal, successMessageToast } from "helpers/common";
import { ADD_PRIVATE_CLIENT, EDIT_PRIVATE_CLIENT } from "config/paths";
import { ArchiveIcon, CalendarIcon, DeleteIcon, EditIcon, UnArchiveIcon } from "Assets/icons";
import { useGetFundingSourceListQuery } from "store/services/utility";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { privateClientsFilter } from "store/slices/filter";
import ExportButton from "components/ExportButton";
import { usePersistentState } from "hooks/usePersistentState";
import TableLayoutV2 from "components/TableLayoutV2";
import { CLIENT_STATUS_OPTION } from "config/constants";
import { debounce } from "lodash";
import { DownArrowIcon } from "Assets/icons/V2";
import confirmDialogV2 from "utils/confirmationDialogV2";
import { Star } from "react-feather";

const ClientPrivate = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const filter = useSelector(state => state?.filter?.privateClientsFilter);

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [currentPage, setCurrentPage] = usePersistentState("private:page", 1);
  const [pageSize, setPageSize] = useState(10);

  const [privateClientList, setPrivateClientList] = useState([]);

  // Funding source filter list
  const { data: fundingSourceList, isLoading: fundingSourceListLoading } = useGetFundingSourceListQuery();

  const [archiveClient, { isLoading: archiveClientLoading }] = useArchivePrivateClientMutation();
  const [deleteClient, { isLoading: deleteClientLoading }] = useDeletePrivateClientMutation();
  const { data, isLoading, isError, isFetching } = useGetPrivateClientListQuery({ page: currentPage, limit: pageSize, ...filter });
  const [updateStatus, { updateStatusLoading }] = useUpdatePrivateClientStatusMutation();
  const [favouriteClient, { isLoading: favouriteClientLoading }] = useFavouritePrivateClientMutation()
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const handleFavouriteReport = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      const response = await favouriteClient({ data, id }).unwrap()
      successMessageToast(response?.message)
    } catch (error) {
      console.log('error making the client favourite: ', error)
    }
  }

  const column = [
    {
      head: <div onClick={() => {
        handleFilterChange("sort")(filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "asc" } : { column: "is_favorite", direction: "desc" })
        // dispatch(schoolClientsFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "asc" } : { column: "is_favorite", direction: "desc" } }))
      }
      }>{filter?.sort?.column == "is_favorite" ? <Star fill="#315D99" stroke="#315D99" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
      accessor: "is_favorite",
      isComponent: true,
      component: (item, ind) => (
        <h6 style={{ cursor: "pointer" }} className="m-0 text-capitalize cursor-pointer d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteReport(item?.client_detail?.id, item?.client_detail?.is_favorite ? 0 : 1) }}>{item?.client_detail?.is_favorite ? <Star fill="#315D99" stroke="#315D99" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
      ),
    },
    {
      head: "Last Name",
      accessor: "lastname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item.lastname}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "firstname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item.firstname}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "dob",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{dateFormatLocal(item?.client_detail?.dob, "MMM DD, YYYY")}</h6>
      ),
    },
    {
      head: "Submitted Date",
      accessor: "submittedDate",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{dateFormatLocal(item?.createdAt, "MMM DD, YYYY")}</h6>
      )
    },
    {
      head: <div className="w-100 text-center">Funding Source</div>,
      accessor: "FundingSource",
      isComponent: true,
      component: (item, ind) => (
        <div className="w-100 text-center"><h6 className="m-0 fw-sbold">{item?.client_detail?.client_private_detail?.private_funding_source?.name || "--"}</h6></div>
      )
    },
    {
      head: "Discipline",
      accessor: "reportsPreflightOwner",
      isComponent: true,
      component: (item, ind) => {
        const disciplines =
          item?.clientCaseloads?.[0]?.clientCaseloadTherapist?.map(
            (ct) => ct?.caseDiscipline?.assign_term
          ) || [];
        return (
          <div className="d-flex flex-wrap gap-2">
            {disciplines?.length > 0 ? (
              disciplines?.map((term, index) => (
                <span
                  key={index}
                  className={`discipline-${term}-capsule-bcg`}
                  style={{ borderRadius: "8px", padding: "7px 10px", }}
                >
                  {term}
                </span>
              ))
            ) : (
              <span>--</span>
            )}
          </div>
        );
      }
    },
    {
      head: "Source",
      accessor: "source",
      isComponent: true,
      sorter: false,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item.client_detail?.source}</h6>
      ),
    },
    // {
    //   head: "End Date",
    //   accessor: "EndDate",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <h6 className="m-0 fw-sbold">{convertToMomentDate(item?.client_detail?.client_private_detail?.end_date)}</h6>
    //   )
    // },
    {
      head: "Account Status",
      accessor: "status",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <div>
          <Dropdown
            onClick={(e) => e.stopPropagation()}
          >
            <Dropdown.Toggle
              variant="transparent"
              className="p-0 border-0 text-dark w-100 d-flex align-items-center gap-0"
              id="dropdown-basic"
            >
              <p
                style={{ width: 80, fontStyle: item?.status != "active" && "italic" }}
                className={`${item.status == "active"
                  && "greenStatus"
                  // : "redStatus"
                  } status text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-2 py-1`}
              >
                {item.status}
              </p>
              <DownArrowIcon />

            </Dropdown.Toggle>

            <Dropdown.Menu className="" style={{ right: 0, left: "unset", minWidth: "150px" }}>
              <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                {CLIENT_STATUS_OPTION
                  .filter((status) =>
                    // {
                    status.value != item.status && status?.value
                    //   const currentStatus = item?.status;
                    //   if (currentStatus === "active") {
                    //     return ["Inactive", "Archive", "Discharged"].includes(status.label);
                    //   }

                    //   if (currentStatus === "inactive") {
                    //     return ["Active", "Archive", "Discharged"].includes(status.label);
                    //   }

                    //   if (currentStatus === "archived") {
                    //     return status.label === "Unarchive";
                    //   }
                    //   if (currentStatus === "discharged") {
                    //     return ["Active", "Inactive", "Archive"].includes(status.label);
                    //   }
                    //   return false;
                    // 
                    // }
                  )
                  .map((status) => (
                    <h5
                      key={status.value}
                      onClick={(e) => {
                        e.stopPropagation();
                        // setCurrentEntry(item);
                        // setModalType(status?.value === "archived" ? "archive" : status?.value);
                        // setNewStatus(status?.value)
                        // setIsStatusModal(true)
                        handleUpdateStatus(e, status?.value, item?.id);
                      }}
                      className="cursor-pointer proxima mb-2"
                    >
                      {status.label}
                    </h5>
                  ))
                }
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
    // {
    //   head: "Action",
    //   accessor: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <div className="ActnBtn d-flex align-items-center  gap-10">
    //       <CommonToolTip
    //         text={"Edit"}
    //         component={<Button
    //           className="p-0"
    //           variant="transparent"
    //           type="button"
    //           onClick={(e) => {
    //             e.stopPropagation()
    //             navigate(EDIT_PRIVATE_CLIENT.replace(":id", item.id));
    //           }}
    //         >
    //           <EditIcon />
    //         </Button>}
    //       />
    //       <CommonToolTip
    //         text={item?.status == "active" ? "Archive" : "Unarchive"}
    //         component={<Button
    //           onClick={(e) => {
    //             e.stopPropagation()
    //             setCurrentEntry(item);
    //             setModalType(item?.status == "active" ? "archive" : "active");
    //             setShowModal(true);
    //           }}
    //           className="p-0"
    //           variant="transparent"
    //           type="button"
    //         >
    //           {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
    //         </Button>}
    //       />
    //       <CommonToolTip
    //         text={"Delete"}
    //         component={<Button
    //           className="p-0"
    //           variant="transparent"
    //           type="button"
    //           onClick={(e) => {

    //             e.stopPropagation();
    //             setCurrentEntry(item);
    //             setModalType("delete");
    //             setShowModal(true);
    //           }}
    //         >
    //           <DeleteIcon />
    //         </Button>}
    //       />
    //     </div>
    //   ),
    // },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Dropdown
            onClick={(e) => e.stopPropagation()}
          // show={index == dropdownIndex}
          // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
          >
            <Dropdown.Toggle
              variant="transparent"
              className="p-0 border-0 text-dark w-100"
              id="dropdown-basic"
            >
              <span className="icn ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="13"
                  viewBox="0 0 28 13"
                  fill="none"
                >
                  <rect width="28" height="13" rx="6.5" fill="" />
                  <path
                    d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                    fill="#8f8f8f"
                  />
                  <path
                    d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                    fill="#8f8f8f"
                  />
                  <path
                    d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                    fill="#8f8f8f"
                  />
                </svg>
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
              <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                <h5 onClick={(e) => {

                  e.stopPropagation();
                  handleEditItem(item.id);
                }} className="cursor-pointer proxima mb-2">
                  Edit
                </h5>
                {/* <h5 onClick={(e) => {
                         e.stopPropagation();
                         setCurrentEntry(item);
                         setModalType(item?.status == "active" ? "archive" : "active");
                         setShowModal(true);
                       }} className="cursor-pointer proxima mb-2">
                         {item?.status == "active" ? "Archive" : "Unarchive"}
                       </h5> */}
                <h5 onClick={(e) => {

                  e.stopPropagation();
                  setCurrentEntry(item);
                  setModalType("delete")
                  setShowModal(true);
                }}
                  className="cursor-pointer proxima mb-2">
                  Delete
                </h5>
              </ul>
            </Dropdown.Menu>
          </Dropdown>

          {
            item?.status == "complete" && <div
              className="cursor-pointer d-flex align-items-center"
              style={{ padding: "10px 10px" }}
              onClick={(e) => {
                e.stopPropagation(); // prevent row navigation
                toggleRow(item.id);
              }}
            >
              {openRow === item.id ? (
                <img width={12} src={downArrow} alt="Collapse" />
              ) : (
                <img width={7} src={rightArrow} alt="Expand" />
              )}
            </div>
          }
        </div >
      ),
    },
  ];

  const handleUpdateStatus = async (e, status, clientId) => {
    e.stopPropagation();
    if (updateStatusLoading) return;
    const isConfirm = await confirmDialogV2({
      title: `CLIENT STATUS CHANGE?`,
      message: `Are you sure you want to change the status of this client to ${status}?`,
    });
    if (!isConfirm) {
      return
    }
    try {
      const resp = await updateStatus({ clientId, status: status }).unwrap();
      successMessageToast(resp?.message);
    } catch (error) {
      console.error(error);
    }
  }


  const handleEditItem = (id) => {
    navigate(generatePath(EDIT_PRIVATE_CLIENT, { id }));
  }

  const resetFilter = () => {
    dispatch(privateClientsFilter({ search: "", status: "active", start_date: "", end_date: "", sort: { column: "lastname", direction: "asc" } }));
    setCurrentPage(1)
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    dispatch(privateClientsFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleSearchChange = useCallback(debounce((value) => {
    setCurrentPage(1);
    handleFilterChange("search")(value);
  }, 500), [handleFilterChange, 500]);

  const handleDelete = async () => {
    try {

      setShowModal(false);

      const list = [...privateClientList];
      const index = privateClientList?.findIndex(x => x.id === currentEntry?.id);
      delete list[index];
      setPrivateClientList(list.filter(Boolean));

      const result = await deleteClient(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error archiving discipline", err);
    };
  };

  const handlArchive = async () => {
    try {

      setShowModal(false);

      const list = [...privateClientList];
      const index = privateClientList?.findIndex(x => x.id === currentEntry?.id);
      list[index] = { ...list[index], status: list[index].status == "active" ? "archived" : "active" };
      setPrivateClientList(list.filter(Boolean));

      const result = await archiveClient(currentEntry?.id);
      if (!result?.error) successMessageToast("Record has been updated successfully.");

    } catch (err) {
      console.error("error archiving client private", err);
    };
  };

  useLayoutEffect(() => {

    if (data?.records) setPrivateClientList(data?.records)
  }, [data]);

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={modalType == "delete" ? handleDelete : handlArchive}
        type={modalType}
      />
      <section className="client position-relative py-4">
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left classroom-conslutation">
                  <h6 className="m-0 fw-bold main-head themeBlue">Private Clients</h6>
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <Link to={ADD_PRIVATE_CLIENT} className="blue-discharge-screen-btn mt-0 d-flex align-items-center justify-content-center">
                        Add a Client
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
            <Col md='3'>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Funding Source</label>
                <CommonSelect
                  placeholder={"Choose one..."}
                  option={fundingSourceList?.map((item) => ({ label: item?.name, value: item?.id }))}
                  onChange={(e) => handleFilterChange("funding_source")(e)}
                  value={filter?.division}
                  // onInputChange={(val) => handleSearch(val)}
                  isFilterV2
                  isClearable
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%", // ✅ Ensures the whole Select container is full width
                    }),
                  }}
                // isLoading={schoolsLoading}
                />
              </div>
            </Col>
            <Col md='2'>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Start Date</label>
                <DatePicker
                  className="form-control"
                  placeholderText="Start Date"
                  selectsStart
                  icon={<CalendarIcon />}
                  showIcon={filter?.start_date ? false : true}
                  isClearable={filter?.start_date ? true : false}
                  selected={filter?.start_date}
                  onChange={(e) => handleFilterChange("start_date")(e)}
                />
              </div>
            </Col>
            <Col md='2'>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">End Date</label>
                <DatePicker
                  className="form-control"
                  placeholderText="End Date"
                  selectsEnd
                  icon={<CalendarIcon />}
                  showIcon={filter?.end_date ? false : true}
                  isClearable={filter?.end_date ? true : false}
                  selected={filter?.end_date}
                  onChange={(e) => handleFilterChange("end_date")(e)}
                />
              </div>
            </Col>
            <Col md='2'>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Status</label>
                <CommonSelect
                  placeholder={"Select"}
                  option={CLIENT_STATUS_OPTION}
                  onChange={(e) => handleFilterChange("status")(e)}
                  value={filter?.status}
                  isFilterV2
                  // isClearable
                  // isLoading={schoolListLoading || schoolListFetching}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%", // ✅ Ensures the whole Select container is full width
                    }),
                  }}
                />
              </div>
            </Col>
            <Col lg="3" style={{ borderLeft: "1px solid #315D99" }}>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Search</label>
                <input
                  onChange={(e) => handleSearchChange(e.target.value)}
                  // style={{outline: "blue"}}
                  className={`input-new readonly-box h-auto search-input-filter-v2`}
                  placeholder="Find a client..."
                  defaultValue={filter?.search}
                />
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                {/* <div className="left">
                  <TableHeader
                    heading={"Private"}
                    handleFilterChange={handleFilterChange}
                    resetFilter={resetFilter}
                    filter={filter}
                    searchPlaceholder="Client Last, First Name"
                    filterComponent={
                      <>
                        <li>
                          <DatePicker
                            className="form-control filter-datepicker"
                            placeholderText="Start Date"
                            selectsStart
                            icon={<CalendarIcon />}
                            showIcon
                            value={filter?.start_date ? moment(filter?.start_date).format("DD-MM-YYYY") : ""}
                            onChange={(e) => handleFilterChange("start_date")(moment(e).format("YYYY-MM-DD"))}
                          />
                        </li>
                        <li>
                          <DatePicker
                            className="form-control filter-datepicker"
                            placeholderText="End Date"
                            selectsEnd
                            icon={<CalendarIcon />}
                            showIcon
                            value={filter?.end_date ? moment(filter?.end_date).format("DD-MM-YYYY") : ""}
                            onChange={(e) => handleFilterChange("end_date")(moment(e).format("YYYY-MM-DD"))}
                          />
                        </li>
                        <li className="">
                          <Dropdown
                            onSelect={handleFilterChange("funding_source")}>
                            <Dropdown.Toggle
                              variant="transparent"
                              className="border-0 d-flex align-items-center  justify-content-center"
                              id="dropdown-basic"
                            >
                              {fundingSourceList?.find(x => x.id == filter.funding_source)?.name || "Funding Source"}
                              <span className="icn ms-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="8"
                                  viewBox="0 0 12 8"
                                  fill="none"
                                >
                                  <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu >
                              <Dropdown.Item eventKey={""}>All</Dropdown.Item>
                              {
                                fundingSourceList?.map((item, index) => {
                                  return <Dropdown.Item
                                    key={index}
                                    eventKey={item.id}
                                    style={filter.funding_source == item.id ? { background: "#f3f3f3" } : {}}
                                  >
                                    {item?.name}
                                  </Dropdown.Item>
                                })
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                      </>
                    }
                  />
                </div> */}
                {/* <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <ExportButton
                      module={"client_private"}
                      filter={filter}
                    />
                    <li className="">
                      <Link
                        to={ADD_PRIVATE_CLIENT}
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                      >
                        <span className="icn me-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <mask
                              id="mask0_0_4440"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="19"
                              height="19"
                            >
                              <rect
                                width="18.7197"
                                height="18.7197"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_0_4440)">
                              <path
                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </span>{" "}
                        Add New Clients
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
              <div className="table-outer">
                {isLoading || fundingSourceListLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || archiveClientLoading || deleteClientLoading || updateStatusLoading || favouriteClientLoading) && <LoadingOverlay />}
                    <TableLayoutV2
                      data={privateClientList}
                      column={column}
                      url={"/client/private/detail"}
                      filter={filter}
                      handleSort={handleFilterChange("sort")}
                    />
                    <CstmPagination
                      totalPages={totalPages}
                      activePage={currentPage}
                      handlePageChange={handlePageChange}
                      className="paginationV2"
                    />
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ClientPrivate;
